import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 保存舱单格式化VGM信息
export function saveManifestVGMInfo(data) {
  return request({
    url: URL.seaExport.saveManifestVGMInfo,
    method: 'post',
    data
  })
}

// 删除舱单格式化VGM信息
export function deleteManifestVGMInfo(params) {
  return request({
    url: URL.seaExport.deleteManifestVGMInfo,
    method: 'delete',
    params
  })
}
